if (!customElements.get('logo-testimonials-slider')) {
  class LogoTestimonialsSlider extends HTMLElement {
    VISIBLE_LOGO_SLIDES_DESKTOP = 5;
    slidesCount = Number(this.getAttribute('data-slides'));

    selectors = {
      contentSlider: '.swiper[logo-testimonial="text-slider"]',
      logoSlider: '.swiper[logo-testimonial="image-slider"]',
      logoSlide: '.swiper[logo-testimonial="image-slider"] .swiper-slide',
    };

    contentSettings = {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      allowTouchMove: false,
    };

    logoSettings = {
      slidesPerView: this.VISIBLE_LOGO_SLIDES_DESKTOP,
      centerInsufficientSlides:
        this.slidesCount < this.VISIBLE_LOGO_SLIDES_DESKTOP,
      loop: this.slidesCount >= this.VISIBLE_LOGO_SLIDES_DESKTOP,
      slideToClickedSlide: true,
      centeredSlides: true,
      loopAdditionalSlides: 5,
      spaceBetween: 112,
      centeredSlidesBounds: this.slidesCount < this.VISIBLE_LOGO_SLIDES_DESKTOP,
      autoplay: this.hasAttribute('slider-autoplay')
        ? {
            delay: this.getAttribute('slider-autoplay'),
          }
        : false,
      breakpoints: {
        240: {
          slidesPerView: 2.3,
          spaceBetween: 22,
        },
        640: {
          slidesPerView: 3,
        },
        990: {
          spaceBetween: 50,
          slidesPerView: this.VISIBLE_LOGO_SLIDES_DESKTOP,
        },
        1100: {
          spaceBetween: 100,
        },
        1300: {
          spaceBetween: 112,
        },
      },
    };

    contentSlider = undefined;
    logoSlider = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const contentSlider = this.querySelector(this.selectors.contentSlider);
      const logoSlider = this.querySelector(this.selectors.logoSlider);

      if (!contentSlider || !logoSlider) return;

      this.contentSlider = new Swiper(contentSlider, this.contentSettings);
      this.logoSlider = new Swiper(logoSlider, this.logoSettings);

      if (this.VISIBLE_LOGO_SLIDES_DESKTOP > this.slidesCount) {
        [...this.querySelectorAll(this.selectors.logoSlide)].forEach(
          (slide) => {
            slide.addEventListener('click', this.handleSlideClick.bind(this));
          },
        );
      } else {
        this.logoSlider.on(
          'activeIndexChange',
          this.handleLogoSlideChange.bind(this),
        );
      }

      this.syncSliders();

      if (Shopify.designMode) {
        this.addEventListener(
          'shopify:block:select',
          this.handleBlockSelect.bind(this),
        );
      }
    }

    /**
     * Synchronize sliders.
     * @returns {Void}
     */
    syncSliders() {
      const activeSlide = this.querySelector(
        `${this.selectors.logoSlide}.swiper-slide-active`,
      );

      if (!activeSlide) {
        return;
      }

      this.contentSlider.slideTo(activeSlide.getAttribute('data-index'));
    }

    /**
     * Handle slide click when slider is disabled.
     * @param {Object} e Event
     * @returns {Void}
     */
    handleSlideClick(e) {
      const index = Number(e.target.getAttribute('data-index'));

      if (Number.isNaN(index)) {
        return;
      }

      this.contentSlider.slideTo(index);
      this.querySelectorAll(this.selectors.logoSlide).forEach((slide) => {
        slide.classList.remove('swiper-slide-active');
      });
      e.target?.classList.add('swiper-slide-active');
    }

    /**
     * Handle logo slide change.
     * @param {Object} e Event
     */
    handleLogoSlideChange(e) {
      setTimeout(() => {
        this.contentSlider.slideTo(
          this.logoSlider.slides
            .find((slide) => slide.classList.contains('swiper-slide-active'))
            ?.getAttribute('data-index'),
        );
      }, 50);
    }

    /**
     * Handle Shopify admin section block select.
     * @param {Object} e Event
     */
    handleBlockSelect(e) {
      const targetIndex = Number(e.target?.getAttribute('data-index'));

      if (!Number.isNaN(targetIndex)) {
        this.logoSlider.slideToLoop(targetIndex, 0);
      }
    }
  }
  customElements.define('logo-testimonials-slider', LogoTestimonialsSlider);
}
